export enum LUXON_RANGE_TYPE {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
  HOUR = 'hour',
}
